import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap';
import ToggleButton from "react-toggle-button";

function ViewGlossary(props) {
    const {
        setViewModalFlag
    } = props
    const [title, setTitle] = useState<string>("")
    const [des, setDes] = useState<string>("")
    const [letter, setLetter] = useState<string>("")
    const [status, setStatus] = useState<boolean>(false)
    const borderRadiusStyle = { borderRadius: 2 };
    const [loadingData, setLoadingData] = useState<boolean>(false)


    useEffect(() => {
        setLoadingData(true)
        const obj = JSON.parse(sessionStorage.getItem("GlossaryObj") || "");
        setTitle(obj?.title?.trim() || "")
        setDes(obj?.description?.trim() || "")
        setLetter(obj?.letter || "")
        setStatus(obj?.status)
        setLoadingData(false)
    }, [])


    return (
        <Col md="12" className='px-0'>
            <Container fluid>
                {!loadingData ?
                    <Row>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                    className="form-control"
                                    placeholder='Enter Title'
                                    value={title}
                                    disabled
                                />
                            </div>
                            {/* {nameError === true ? (
                                  <p className="error-labels">Name is Required.</p>
                                ) : (
                                  ""
                                )} */}
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    rows={3}
                                    className="form-control"
                                    placeholder='Enter Description'
                                    value={des}
                                    disabled
                                />
                            </div>
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Letter</label>
                                <input
                                    className="form-control"
                                    placeholder='Enter Letter'
                                    value={letter}
                                    disabled
                                />
                            </div>
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Status</label>
                                <ToggleButton
                                    inactiveLabel=""
                                    activeLabel=""
                                    value={status}
                                    thumbStyle={borderRadiusStyle}
                                    trackStyle={borderRadiusStyle}

                                />
                            </div>
                        </Col>
                    </Row> :
                    <div className="d-flex justify-content-center my-5">
                        <div
                            className="fa fa-spinner fa-spin fa-3x mt-5 mb-5"
                            role="status"
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                }
                <Row className='d-flex justify-content-between'>
                    <Button
                        onClick={() => setViewModalFlag(false)}
                    >
                        Cancel
                    </Button>
                </Row>
            </Container>
        </Col>
    )
}

export default ViewGlossary